import { render, staticRenderFns } from "./ProfilerDetail.vue?vue&type=template&id=76eb3d88"
import script from "./ProfilerDetail.vue?vue&type=script&lang=js"
export * from "./ProfilerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports